import store from '@/store/store'
import * as actions from '../store/actions/types'
import { router } from '@/router/router'

class Request {
  _silent = false
  _profileCheck = false
  _isPrivacyPolicyError = false
  _options = {
    method: 'GET',
    headers: { Accept: 'application/json' }
  }

  _prepareOptions = (opts) => {
    const options = { ...this._options, ...opts }
    if (options.body && options.body instanceof FormData) {
      const tzOffset = -60 * (new Date()).getTimezoneOffset()
      options.body.append('_tz_offset', tzOffset)
    }

    return options
  }

  _prepareResponse = (response) => {
    if (!this._silent && !this._profileCheck) {
      this._handleErrors(response.status)
    }

    return response.json()
  }

  _showAlerts = (response) => {
    const notifications = []

    ;(response.errors || []).forEach(m => notifications.push({
      type: 'error',
      msg: m
    }))

    ;(response.warnings || []).forEach(m => notifications.push({
      type: 'warning',
      msg: m
    }))

    ;(response.info || []).forEach(m => notifications.push({
      type: 'info',
      msg: m
    }))

    ;(response.success || []).forEach(m => notifications.push({
      type: 'success',
      msg: m
    }))

    store.dispatch(actions.CREATE_NOTIFICATIONS, notifications)
  }

  _handleErrors = (code) => {
    const ERROR_CODE_FORBIDDEN = 403
    const ERROR_CODE_UNAUTHORIZED = 401

    if (code === ERROR_CODE_FORBIDDEN || code === ERROR_CODE_UNAUTHORIZED) {
      setTimeout(() => {
        if (!this._isPrivacyPolicyError) {
          location.reload()
        }
      }, 10 * 1000)
    }
  }

  _handleResponse = (response) => {
    if (response instanceof Error) {
      response = {
        errors: ['Что-то пошло не так, попробуйте попозже.']
      }
    }

    this._showAlerts(response)

    if (this._profileCheck) {
      if (response.errors && response.errors[0].includes('Заполните в своём профиле')) {
        const str = response.errors[0]
        const searchString = str.includes('поля') ? 'поля: ' : 'поле '
        const startIndex = str.indexOf(searchString)
        const _from = window.location.pathname

        const _field = str
          .substring(startIndex + searchString.length)
          .split(',')
          .map(item => item.trim())[0]

        const userID = store.getters?.ACCOUNT?.id
        router.push({ name: 'user-edit', params: { userID }, query: { settings: 'base-information', _field, _from } }).catch(() => {})
      }
    }

    if (response.errors && response.errors[0].includes('Примите политику обработки')) {
      this._isPrivacyPolicyError = true
      router.push({ name: 'privacy-policy' })
      return
    }

    if (response.errors) {
      throw new Error(response.errors[0])
    }

    return response
  }

  do = (url, opts, silent = false, profileCheck = false) => {
    const options = this._prepareOptions(opts)
    this._silent = silent
    this._profileCheck = profileCheck

    return fetch(url, options)
      .then(this._prepareResponse)
      .catch(this._handleResponse)
      .then(this._handleResponse)
  }
}

export const request = new Request().do
